<template>
  <div
    class="mc-video-history-new__main-content-container"
    :class="{
      'full-video': screenMode === 'fullVideo',
      'full-playlist': screenMode === 'fullPlaylist',
    }"
  >
    <!-- TODO: Remove from getters computed -->
    <!-- THIS IS FOR DEBUGGING ONLY -->
    <!-- <div style="position: absolute; z-index: 9; right: 0"> -->
    <!-- {{ modalOpen }} -->
    <!-- {{ statusTextActive }}
      {{ deviceTypeActive }}
      {{ normalizedChannels }} -->
    <!-- {{ $store.state.videoHistory.videoChannelActive }} -->
    <!-- {{ $store.state.videoHistory.mapWebviewStatePerChannel }} -->
    <!-- {{ markerTimelineDate }}  -->
    <!-- {{ markerTimelineDate }}
      {{ $store.state.videoHistory.mapWebviewBufferedTimePerChannel }} -->
    <!-- </div> -->
    <HeaderSection />
    <VideoSection />
    <div class="mc-video-history-new__chevron-toggle-wrapper">
      <div class="mc-video-history-new__chevron-toggle-up" @click="clickChevronUp">
        <i class="icon-fill_chevron-up"></i>
      </div>
      <div class="mc-video-history-new__chevron-toggle-down" @click="clickChevronDown">
        <i class="icon-fill_chevron-down"></i>
      </div>
    </div>
    <div v-if="loadingGetVehicles" class="mc-video-history-new__main-content-loading">
      <b-spinner />
    </div>
    <PlaylistSection
      v-else
      :status-text="statusTextActive"
      :device-type-active="deviceTypeActive"
    />
  </div>
</template>

<script>
import HeaderSection from './HeaderSection.vue'
import { GET_VEHICLE_VIDEO_TRACKERS_VIDEO_HISTORY } from '../../../../services/api/trackvideo/video'
import { mapGetters, mapState } from 'vuex'
import PlaylistSection from './PlaylistSection/index.vue'
import VideoSection from './VideoSection/index.vue'

export default {
  name: 'MainContentVideoHistory',
  components: {
    HeaderSection,
    PlaylistSection,
    VideoSection,
  },
  data() {
    return {
      wsMessageHandler: null,
      screenMode: 'default', // default | fullVideo | fullPlaylist
    }
  },
  computed: {
    ...mapGetters('videoHistory', [
      'deviceTypeActive',
      'statusTextActive',
      'normalizedChannels',
      'markerTimelineDate',
    ]),
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    ...mapState('videoHistory', [
      'modalOpen',
      'vehicleIdActive',
      'tempVehicleId',
      'vehicleStatuses',
      'loadingGetVehicles',
    ]),
  },
  async mounted() {
    this.$store.commit('videoHistory/setVehicleIdActive', null)

    let vehicleIdActive = null
    if (this.$route.query.vehicleId) {
      vehicleIdActive = Number(this.$route.query.vehicleId)
    }

    if (this.$route.query.startTime && this.$route.query.endTime) {
      this.$store.commit('videoHistory/setPeriod', [
        this.$route.query.startTime,
        this.$route.query.endTime,
      ])
    }

    await this.loadDataVehicleVideoTrackers()

    this.$store.commit('videoHistory/setVehicleIdActive', vehicleIdActive)
    await this.$nextTick()
    if (vehicleIdActive) {
      await this.$store.dispatch('videoHistory/getAllContentVideoHistory')
    }

    await this.setupWebsocket()
  },
  beforeDestroy() {
    if (this.wsMessageHandler) {
      this.$store.dispatch('ws/unregisterMessageHandler', this.wsMessageHandler)
    }
  },
  methods: {
    clickChevronUp() {
      if (this.screenMode === 'default') {
        this.screenMode = 'fullPlaylist'
      } else if (this.screenMode === 'fullVideo') {
        this.screenMode = 'default'
      }
    },
    clickChevronDown() {
      if (this.screenMode === 'default') {
        this.screenMode = 'fullVideo'
      } else if (this.screenMode === 'fullPlaylist') {
        this.screenMode = 'default'
      }
    },
    async ensureWebSocketConnected() {
      try {
        const wsToken = localStorage.getItem('wsToken')
        const payload = localStorage.getItem('payload')
        if (!wsToken) return

        // Use centralized WebSocket connection
        // ws/WSConnect already handles all connection logic and waiting
        if (!this.$store.state.ws.socket.isConnected) {
          const wsUrl = `${process.env.VUE_APP_WS_URL}/ws?token=${wsToken}`
          // WSConnect returns a promise that resolves when connected
          // It handles race conditions and waits for ongoing connections automatically
          await this.$store.dispatch('ws/WSConnect', wsUrl)
        }

        // Send payload if connected and not already initialized
        // Only send if App.vue hasn't already sent the initial payload
        if (
          this.$store.state.ws.socket.isConnected &&
          payload &&
          !this.$store.state.ws.isInitialized
        ) {
          this.$store.dispatch('ws/updateTags', payload)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to ensure WebSocket connection:', error)
      }
    },
    handleWebSocketMessage(message) {
      const signal = typeof message === 'string' ? JSON.parse(message) : message
      if (signal.type.startsWith('gps-')) {
        const vehicleId = Number(signal.type.slice(4))

        if (!this.vehicleStatuses[vehicleId]) return

        if (this.vehicleIdActive === vehicleId || this.tempVehicleId === vehicleId) {
          this.$store.commit('videoHistory/setVehicleStatusesByVehicleId', {
            vehicleId,
            data: {
              calculatedMotionStatus: signal.payload.calculatedMotionStatus,
              engineOn: signal.payload.engineOn,
              lastReceive: signal.payload.lastReceive,
            },
          })
        } else {
          this.$store.commit('videoHistory/setTempVehicleStatusesByVehicleId', {
            vehicleId,
            data: {
              calculatedMotionStatus: signal.payload.calculatedMotionStatus,
              engineOn: signal.payload.engineOn,
              lastReceive: signal.payload.lastReceive,
            },
          })
        }
      }
    },
    async setupWebsocket() {
      this.wsMessageHandler = this.handleWebSocketMessage.bind(this)
      await this.$store.dispatch('ws/registerMessageHandler', this.wsMessageHandler)

      // Ensure websocket is connected and send payload
      await this.ensureWebSocketConnected()
    },

    async loadDataVehicleVideoTrackers() {
      this.$store.commit('videoHistory/setLoadingGetVehicles', true)
      const response = await this.$apollo.query({
        query: GET_VEHICLE_VIDEO_TRACKERS_VIDEO_HISTORY,
        variables: {
          filter: {
            motionStatus: this.hasAccess(['assisted_motion_status:read'])
              ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
              : undefined,
          },
        },
        fetchPolicy: 'no-cache',
      })
      const dataVehicle = response.data.vehicleVideoTrackers.vehicleVideoTrackers
      const vGroups = []
      const vehicleType = []
      const vehicleStatuses = {}
      dataVehicle.forEach((data) => {
        vehicleStatuses[data.vehicleId] = data
        const groups = data.vehicle.vehicle2Vgroup
        groups.forEach((group) => {
          if (!vGroups.some((g) => g.vgroupId === group.vgroupId)) {
            vGroups.push(group)
          }
        })
        if (
          !vehicleType.some((vt) => vt.vehicleTypeId === data.vehicle.vehicleType.vehicleTypeId)
        ) {
          vehicleType.push(data.vehicle.vehicleType)
        }
      })
      this.$store.commit('videoHistory/setVgroups', vGroups)
      this.$store.commit('videoHistory/setVehicleTypes', vehicleType)
      this.$store.commit('videoHistory/setVehicleStatuses', vehicleStatuses)
      this.$store.commit('videoHistory/setLoadingGetVehicles', false)
    },
  },
}
</script>
